const TOAST_CONTAINER_ID = 'iww-reader-toast-container';
const TOAST_ELEMENT_ID = 'iww-reader-toast';

function ensureToastContainer() {
    let container = document.getElementById(TOAST_CONTAINER_ID);

    if (!container) {
        container = document.createElement('div');
        container.id = TOAST_CONTAINER_ID;
        container.className = 'fixed left-1/2 top-4 -translate-x-1/2 z-[9999] pointer-events-none';
        document.body.appendChild(container);
    }

    return container;
}

function createToastElement(message) {
    const toast = document.createElement('div');
    toast.id = TOAST_ELEMENT_ID;
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.className = 'pointer-events-auto inline-flex items-center gap-2 rounded-xl border border-surface-border bg-surface-background px-4 py-3 text-sm font-medium text-neutral shadow-xs opacity-0 translate-y-2 transition-all duration-300';
    toast.innerHTML = '<span class="before:font-icomoon before:content-checkmark-circle before:text-xl before:text-primary-on-surface" aria-hidden="true"></span><span data-reader-toast-message></span>';
    toast.querySelector('[data-reader-toast-message]').textContent = message;
    return toast;
}

let hideTimeout = null;

function showToast(message) {
    const container = ensureToastContainer();
    let toast = document.getElementById(TOAST_ELEMENT_ID);

    if (!toast) {
        toast = createToastElement(message);
        container.appendChild(toast);
    } else {
        toast.querySelector('[data-reader-toast-message]').textContent = message;
    }

    requestAnimationFrame(() => {
        toast.classList.remove('opacity-0', 'translate-y-2');
    });

    if (hideTimeout) {
        clearTimeout(hideTimeout);
    }

    hideTimeout = window.setTimeout(() => {
        toast.classList.add('opacity-0', 'translate-y-2');
        hideTimeout = null;
    }, 3000);
}

document.addEventListener('iww:issue-completed', () => showToast('Ausgabe abgeschlossen.'));
document.addEventListener('iww:source-reference-copied', () => showToast('Quellenverweis kopiert'));
